module.exports = __webpack_public_path__ + "img/x12.f9d094b0.jpg";